<div class="icip-review">
  <div class="icip-review__shell">
    <div class="icip-review__top">
      <span class="icip-review__secure">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        Secure
      </span>
    </div>

    <h4 class="card-title text-start">Review Setup</h4>
    <p class="card-text mb-4 text-start">Confirm your details before proceeding to checkout.</p>

    <!-- Plan summary -->
    <div class="card icip-review__box">
      <div class="card-body">
        <div class="icip-review__plan-head">
          <div>
            <div class="icip-review__plan-name">{{ plan.planName }} Plan</div>
            <div class="icip-review__plan-billing">{{ billingLabel }}</div>
          </div>
          <div class="icip-review__plan-price">
            <span class="icip-review__plan-price-value">{{ plan.currencySymbol }}{{ formatPrice(plan.pricePerMonth) }}</span>
            <span class="icip-review__plan-price-unit">/mo</span>
          </div>
        </div>

        <div class="icip-review__divider"></div>

        <ul class="icip-review__features" role="list">
          <li class="icip-review__feature" *ngFor="let f of plan.features; trackBy: trackByString">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            {{ f }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Business details -->
    <div class="card icip-review__box">
      <div class="card-body">
        <div class="icip-review__business-head">
          <span class="icip-review__business-title">Business Details</span>
          <span *ngIf="business" class="icip-review__status-badge icip-review__status-badge--{{ business.status | lowercase }}">
            {{ business.status }}
          </span>
        </div>

        <!-- Skeleton while loading -->
        <ng-container *ngIf="businessLoading">
          <div class="icip-review__skeleton">
            <div class="icip-review__skeleton-row">
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--label"></div>
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--value"></div>
            </div>
            <div class="icip-review__skeleton-row">
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--label"></div>
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--value"></div>
            </div>
            <div class="icip-review__skeleton-row">
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--label"></div>
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--value icip-review__skeleton-bar--short"></div>
            </div>
            <div class="icip-review__skeleton-row">
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--label"></div>
              <div class="icip-review__skeleton-bar icip-review__skeleton-bar--value icip-review__skeleton-bar--short"></div>
            </div>
          </div>
        </ng-container>

        <!-- Real data -->
        <ng-container *ngIf="!businessLoading && business">
          <div class="icip-review__field">
            <span class="icip-review__field-label">Company</span>
            <span class="icip-review__field-value">{{ business.name }}</span>
          </div>

          <div class="icip-review__field">
            <span class="icip-review__field-label">Address</span>
            <span class="icip-review__field-value">
              {{ business.address }}<br />
              {{ businessAddressLine }}
            </span>
          </div>

          <div class="icip-review__field">
            <span class="icip-review__field-label">Country</span>
            <span class="icip-review__field-value">{{ business.countryName }}</span>
          </div>

          <div class="icip-review__field" *ngIf="business.crn">
            <span class="icip-review__field-label">Registration No.</span>
            <span class="icip-review__field-value">{{ business.crn }}</span>
          </div>
        </ng-container>

        <!-- Fallback if fetch failed -->
        <ng-container *ngIf="!businessLoading && !business">
          <p class="icip-review__field-value" style="color: #9aa3af; font-size: 13px;">
            Business details unavailable — please verify your details after checkout.
          </p>
        </ng-container>
      </div>
    </div>

    <!-- Referral code captured from a shared link — applied & validated at checkout -->
    <div *ngIf="referralCode" class="icip-review__referral" role="status">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M20 6 9 17l-5-5" />
      </svg>
      Referral code <strong>{{ referralCode }}</strong> will be applied at checkout.
    </div>

    <button type="button" class="btn btn-secondary w-100 icip-review__cta" (click)="proceedToCheckout()">
      Proceed to Checkout
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M5 12h14" />
        <path d="M13 6l6 6-6 6" />
      </svg>
    </button>

    <div class="icip-review__foot">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="2" y="5" width="20" height="14" rx="2" ry="2" />
        <path d="M2 10h20" />
      </svg>
      Stripe
      <span class="icip-review__foot-dot">&middot;</span>
      256-bit Encryption
    </div>
  </div>
</div>
